import React from "react"
import moment from "moment-timezone"

import { Loading } from "@common/EcosuiteComponent"
import { GRAPH_COLORS } from "@common/module/EcosuiteView"

import { ResponsiveContainer, ComposedChart, Bar, XAxis, CartesianGrid, Tooltip, Legend, YAxis } from "recharts"

import DateRangeGraph from "@dashboard/energy/graphs/DateRangeGraph"
import { EnergyGraphTooltip } from "@dashboard/energy/graphs/EnergyGraphTooltip"
import GraphUtils from "@common/utils/GraphUtils"

export default class ConsumptionGenerationBarGraph extends DateRangeGraph {
  renderContent() {
    if (this.props.graphDatums && this.props.range) {
      let data = Object.keys(this.props.graphDatums).map((dateKey) => {
        let entry = this.props.graphDatums[dateKey]
        let date = moment(dateKey)

        return {
          date: date.toDate(),
          time: date.toDate().getTime(),
          name: date.format("lll"),
          predictedConsumption:
            this.props.predictedConsumptionDatums && this.props.predictedConsumptionDatums[dateKey] ? this.round(this.props.predictedConsumptionDatums[dateKey].predictedConsumption) : null,
          consumption: this.round(entry.consumption),
        }
      })

      let aggregation = this.props.aggregation
      let graphType = aggregation === "day" ? "linear" : "monotone"

      return (
        <ResponsiveContainer width="100%" height={250} className="econode-tooltip">
          <ComposedChart data={data} margin={{ top: 5, right: 30, left: 0, bottom: 10 }} onClick={this.zoomDateRange}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={false} />
            <XAxis
              scale="band"
              dataKey="time"
              domain={this.getDomain(this.props.range, this.props.aggregation)}
              tickFormatter={(time) => {
                return GraphUtils.dateFormat(time, this.props.range, this.props.aggregation)
              }}
            />
            <YAxis />
            <Tooltip content={<EnergyGraphTooltip assets={this.props.assets} getDataTitle={getDataTitle} range={this.props.range} aggregation={this.props.aggregation} />} />
            <Legend iconType="plainline" />

            {/* Render Bars */}
            {this.props.showConsumption && (
              <>
                <Bar name={getDataTitle("consumption")} type={graphType} dataKey="consumption" stroke={GRAPH_COLORS[0]} fill={GRAPH_COLORS[0]} dot={aggregation === "day"} />

                {/* Render forecast consumption if it is enabled (if predictedConsumption is not null) */}
                {this.props.predictedConsumptionDatums && (
                  <Bar name={getDataTitle("predictedConsumption")} type={graphType} dataKey="predictedConsumption" stroke={GRAPH_COLORS[1]} fill={GRAPH_COLORS[1]} dot={aggregation === "day"} />
                )}
              </>
            )}

            {this.props.referenceLine ? this.props.referenceLine : null}

            {this.renderUserAlerts()}
            {this.renderAssetEvents()}
          </ComposedChart>
        </ResponsiveContainer>
      )
    }

    return <Loading />
  }
}

export var getDataTitle = function (name) {
  switch (name) {
    case "predictedConsumption":
      return "Forecast Consumption"
    case "consumption":
      return "Consumption"
    default:
      return name
  }
}
